import { isDefined } from './null-empty-undefined-check';

export const safeStringify = (value: unknown): string | null | undefined => {
  if (!isDefined(value)) {
    return value;
  }
  // eslint-disable-next-line functional/no-try-statement
  try {
    return JSON.stringify(value) ?? String(value);
  } catch {
    return String(value);
  }
};
